import React from 'react';
import LayerMap from './LayerMap';
import { motion } from "framer-motion";

const Contact = () => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: .2, ease: "easeInOut" }}
        >
            <div className="py-10 w-full text-3xl font-bold text-green-main mb-4 relative md:py-14">
                <h1 className="mx-auto w-fit relative before:absolute after:absolute before:w-1/2 after:w-1/2 md:before:w-full md:after:w-full before:h-[1px] after:h-[1px] before:bg-green-main after:bg-green-main before:top-1/2 after:top-1/2 before:right-full after:left-full before:mr-2 after:ml-2">Kontakt</h1>
            </div>
            <div className="mx-auto px-4 pb-8 max-w-4xl text-center">
                <h4 className='text-xl font-bold mb-4 text-green-main text-center md:text-3xl'>Potrzebujesz konsultacji? Skontaktuj się z nami!</h4>
                <p>W <span className="text-green-main font-bold">Natur Med</span> zajmujemy się wszystkimi problemami związanymi ze zdrowiem.</p>
                <p className='pb-4'>Skontaktuj się z nami i skorzystaj z naszych usług, żeby poprawić swoje życie!</p>
                <ul className='flex flex-col gap justify-center items-center'>
                    <li>+48 503 603 723</li>
                    <li>mail@example.com</li> {/*TODO*/}
                    <li>ul. Jana III Sobieskiego 39</li>
                    <li>32-650 Kęty</li>
                </ul>
            </div>
            <div className='z-10 relative'>
                <h4 className='text-xl font-bold mb-4 text-green-main text-center md:text-2xl'>Znajdziesz nas tutaj!</h4>
                <LayerMap />
            </div>
        </motion.div>
    );
};

export default Contact;